import I18nHelper from 'common/helpers/I18nHelper';
const translationsNamespace = ['translations'];
const nsTranslate = I18nHelper.getTranslate(translationsNamespace);

export default class FileSizeUtil {
    static formatBytes(bytes, decimals = 2) {
        if (bytes === 0) return `0 ${nsTranslate('fileSize.bytes')}`;

        const k = 1024;
        const dm = decimals < 0 ? 0 : decimals;
        const sizes = [
            nsTranslate('fileSize.bytes'),
            nsTranslate('fileSize.KB'),
            nsTranslate('fileSize.MB'),
            nsTranslate('fileSize.GB'),
            nsTranslate('fileSize.TB'),
            nsTranslate('fileSize.PB'),
            nsTranslate('fileSize.EB'),
            nsTranslate('fileSize.ZB'),
            nsTranslate('fileSize.YB')
        ];

        const i = Math.floor(Math.log(bytes) / Math.log(k));

        return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${
            sizes[i]
        }`;
    }
}

export { FileSizeUtil };
